export default "__VITE_ASSET__Cl$XUToK__"